import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;
const CourseService = {
  getList: async () => {
    const response = await apiService.get("/coursesgroup/with-courses");
    return response.data;
  },

  getDetails: async (id) => {
    const response = await apiService.get(`/kampuscourses/${id}/full`);
    return response.data;
  },
};

export default CourseService;
